module.exports = __webpack_public_path__ + "static/media/login-img.f1ebf6d5.png";